if (!customElements.get('product-recommendations')) {
  const resources = new Map();
  const asset = (source, type) => {
    if (!source) return Promise.resolve();
    const url = new URL(source, document.baseURI).href;
    if (resources.has(url)) return resources.get(url);
    const existing = type === 'style'
      ? [...document.querySelectorAll('link[rel="stylesheet"]')].find(node => node.href === url)
      : [...document.scripts].find(node => node.src === url);
    if (existing) return Promise.resolve();
    const promise = new Promise((resolve, reject) => {
      const element = document.createElement(type === 'style' ? 'link' : 'script');
      if (type === 'style') { element.rel = 'stylesheet'; element.href = url; }
      else { element.src = url; element.async = true; }
      element.onload = resolve;
      element.onerror = () => { resources.delete(url); element.remove(); reject(new Error('Recommendation asset unavailable')); };
      document.head.append(element);
    });
    resources.set(url, promise);
    return promise;
  };
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.loading || this.loaded) return;
      if (!('IntersectionObserver' in window)) { this.loadRecommendations(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadRecommendations();
      }, { rootMargin: '0px 0px 300px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async loadRecommendations() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      try {
        const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        const nativeCards = this.hasAttribute('data-quadro-native-collection') || !!this.dataset.scriptUrl;
        const staticCards = this.hasAttribute('data-quadro-static-recommendations');
        if (!recommendations?.innerHTML.trim() || (nativeCards && !recommendations.querySelector('[data-eu-collection-product]')) || (staticCards && !recommendations.querySelector('[data-quadro-recommendation-card]'))) { this.remove(); return; }
        await Promise.allSettled([
          asset(this.dataset.styleUrl, 'style'),
          asset(this.dataset.mediaUrl, 'script').then(() => asset(this.dataset.scriptUrl, 'script'))
        ]);
        if (!this.isConnected) return;
        if (nativeCards || staticCards) recommendations.querySelectorAll('script[src],link[rel="stylesheet"]').forEach(node => node.remove());
        this.replaceChildren(...recommendations.childNodes);
        this.loaded = true;
        window.QuadroEUCollection?.init(this);
        window.QuadroEU?.init(this);
        this.querySelectorAll('template[data-quadro-card-image]').forEach(template => {
          const image = template.content.querySelector('[data-product-image]');
          if (image) template.replaceWith(image.cloneNode(true));
        });
      } catch { this.remove(); }
      finally { this.loading = false; }
    }
  });
}
